import { render } from "./footer-section.vue?vue&type=template&id=a8078376&scoped=true&ts=true"
import script from "./footer-section.vue?vue&type=script&lang=ts"
export * from "./footer-section.vue?vue&type=script&lang=ts"

import "./footer-section.vue?vue&type=style&index=0&id=a8078376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8078376"]])

export default __exports__